export function SchedulingFilledSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/scheduling-filled.svg'"></ng-include>`
    }
}